export default __webpack_public_path__ + "static/media/illustration-elements_second-gradient.162de53b.svg";